import React, { useMemo, useState, useEffect } from 'react'
import styled from 'styled-components'
import { Modal, ModalHeader, ModalBody, ModalFooter, Alert } from 'reactstrap'
import lodash from 'lodash'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import uuid from 'uuid'

import relevantAddressProps from 'containers/OrderEntry/utils/relevantAddressProps'
import Form from '../../../1stlog-ui/src/components/Form'
import Dialog from '../../../1stlog-ui/src/components/Dialog'
import { FieldPrefix } from '../../../1stlog-ui/src/components/Field'
import AddressPicker from 'containers/AddressPickerAdvanced'
import { requestCreate, requestUpdate, requestDelete, requestImport, set } from './actions'
import {
  makeSelectIsLoading,
  makeSelectResult,
  makeSelectError,
  makeSelectIsOpen,
  makeSelectAddress,
  makeSelectIsDelete,
  makeSelectIsImport,
} from './selectors'
import { useCustomer } from 'components/Customer'

const connectRedux = connect(
  createStructuredSelector({
    isLoading: makeSelectIsLoading(),
    isOpen: makeSelectIsOpen(),
    result: makeSelectResult(),
    error: makeSelectError(),
    address: makeSelectAddress(),
    isDelete: makeSelectIsDelete(),
    isImport: makeSelectIsImport(),
  }),
  { requestCreate, requestUpdate, requestDelete, requestImport, set }
)

const AddressModal = (props) => {
  const {
    address: initialAddress,
    set,
    requestCreate,
    requestUpdate,
    requestDelete,
    isImport,
    isOpen,
    isDelete,
    result,
    error,
    isLoading,
  } = props

  const { customer } = useCustomer()

  const [formId, setFormId] = useState(uuid())

  const [initialValues, setInitialValues] = useState({})

  const [form, setForm] = useState({})

  useEffect(() => {
    if (isOpen) {
      setInitialValues({
        address: {
          country: lodash.get(customer, 'postaladdress.country', 'DE'),
          ...lodash.pick(initialAddress || {}, [
            'city',
            'country',
            'name1',
            'name2',
            'name3',
            'street',
            'streetNumber',
            'streetNumberAddition',
            'zip',
            'eori',
            'mail',
            'phone1',
            'prename',
            'surname',
            'ustid',
            'reference',
          ]),
        },
      })
      setFormId(uuid())
    }
  }, [isOpen])

  const onSubmit = ({ address: values }) => {
    if (initialAddress) {
      requestUpdate({
        // ensure empty values are null and not undefined
        ...relevantAddressProps.reduce((o, key) => ({ ...o, [key]: null }), {}),
        ...lodash.omit(initialAddress, relevantAddressProps),
        ...values,
      })
    } else {
      requestCreate(values)
    }
  }

  const remove = () => {
    requestDelete(initialAddress)
  }

  const close = () => {
    set({
      isOpen: false,
    })
  }

  return (
    <Form
      key={formId}
      onSubmit={onSubmit}
      setForm={setForm}
      initialValues={initialValues}
      subscription={{ submitting: true, pristine: true }}
    >
      <Dialog
        isLoading={isLoading}
        onClose={close}
        lg
        isOpen={isOpen && !isImport}
        title={
          isDelete
            ? i18n.t("delete_address", "Adresse löschen")
            : initialAddress
            ? i18n.t("edit_address", "Adresse bearbeiten")
            : i18n.t("add_address", "Adresse hinzufügen")
        }
        closeButton={i18n.t('close', 'Schliessen')}
        onDelete={lodash.get(initialAddress, 'id') ? remove : undefined}
        deleteButton={lodash.get(initialAddress, 'id') ? i18n.t('delete', 'Löschen') : undefined}
        onSubmit={form.submit}
        submitButton={initialAddress ? i18n.t(`save`, `Speichern`) : i18n.t(`add`, `Speichern`)}
      >
        <FieldPrefix prefix="address">
          <AddressPicker showReference withoutAddressbook />
        </FieldPrefix>
      </Dialog>
    </Form>
  )
}

export default connectRedux(AddressModal)
